import Vue from "vue";

Vue.filter("initial", function(user) {
  if (user) {
    return (user.firstName || "").charAt(0).toUpperCase();
  }
});
